import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const complianceCriteria = [
  "PHOTO OF PASSENGER MATCHES THE PASSPORT",
  "PASSPORT WITH THE SAME NAME AS BOARDING PASS",
  "BOARDING PASS",
  "BAG TAGS ATTACHED"
];

function Consent() {
  const navigate = useNavigate();
  const userRole = localStorage.getItem('userRole');
  
  const [checkedItems, setCheckedItems] = useState(
    complianceCriteria.reduce((acc, item) => {
      // Set all checkboxes to true for HBR & Scanning role
      acc[item] = userRole === 'HBR & Scanning';
      return acc;
    }, {})
  );

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setCheckedItems(prev => ({
      ...prev,
      [name]: checked
    }));
  };

  const [error, setError] = React.useState('');

  const handleConfirm = async () => {
    if (Object.values(checkedItems).some(v => v)) {
      setError('');
      if (userRole === 'HBR & Scanning') {
        try {
          
          const adminCode = localStorage.getItem('companyCode'); // Using userId as admin code
          const airlineCode = " ";
          const terminal = localStorage.getItem('terminal');
          const rec_hbrstatus = 'Approved';
          const rec_reasone = 'Eligible - No specific reason';

          const token = localStorage.getItem('token');

          const response = await fetch('https://starskan.com/api/hbr-check', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ adminCode, airlineCode, terminal, rec_hbrstatus, rec_reasone })
          });

          if (!response.ok) {
            const data = await response.json();
            setError(data.message || 'Failed to record HBR check');
            return;
          }

          const data = await response.json();
          if (data.uniqueId) {
            localStorage.setItem('hbrUniqueId', data.uniqueId);
          }

          navigate('/barcode-pdf417-scanner');
        } catch (error) {
          setError('Error connecting to server');
        }
      } else {
        navigate('/login');
      }
    } else {
      setError('Please check at least one item to proceed.');
    }
  };
  
  const handleNonCompliant = async () => {
    const uncheckedReasons = Object.entries(checkedItems)
      .filter(([key, value]) => !value)
      .map(([key]) => key)
      .join(', ');

    if (!uncheckedReasons) {
      setError('Please uncheck at least one item to proceed as Non Compliant.');
      return;
    }

    try {
      const adminCode = localStorage.getItem('companyCode'); // Using userId as admin code
      const airlineCode = " ";//localStorage.getItem('airlineCode');
      const terminal = localStorage.getItem('terminal');
      const rec_hbrstatus = 'Rejected';
      const rec_reasone = uncheckedReasons;

      const token = localStorage.getItem('token');

      const response = await fetch('https://starskan.com/api/hbr-check', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ adminCode,  airlineCode, terminal, rec_hbrstatus, rec_reasone })
      });

      if (!response.ok) {
        const data = await response.json();
        setError(data.message || 'Failed to record HBR check');
        return;
      }

      const data = await response.json();
      if (data.uniqueId) {
        localStorage.setItem('hbrUniqueId', data.uniqueId);
      }

      // Reset checkboxes in Questions page by using localStorage flag
      localStorage.setItem('resetQuestions', 'true');
      navigate('/welcome');
    } catch (error) {
      setError('Error connecting to server');
    }
  };

  // Derived state for button disabled status
  const allChecked = Object.values(checkedItems).every(v => v);
  const confirmButtonDisabled = !allChecked;
  const nonCompliantButtonDisabled = allChecked;


  return (
    <div style={{
      maxWidth: 400,
      margin: 'auto',
      padding: 20,
      backgroundColor: '#f0f0f5',
      borderRadius: 10,
      fontFamily: "'Arial Black', Arial, sans-serif",
      color: '#000',
      textAlign: 'center',
      boxShadow: '0 0 10px rgba(0,0,0,0.1)',
      fontSize: 18,
      lineHeight: 1.4
    }}>
      <img
        src="/arl-logo.png"
        alt="ARL Aviation Services Logo"
        style={{ width: '100%', maxWidth: 250, marginBottom: 20, display: 'block', marginLeft: 'auto', marginRight: 'auto' }}
      />


    <h1 style={{ color: '#000000', fontWeight: 'bold', marginBottom: 40, fontSize: 24, fontFamily: "'Arial Black', Arial, sans-serif" }}>HBR & Scanning</h1>
      <h2 style={{ color: '#2e7d32', fontWeight: 'bold', marginBottom: 20, fontSize: 28, fontFamily: "'Arial Black', Arial, sans-serif" }}>HBR COMPLIANCE</h2>

      <div style={{ textAlign: 'left', fontWeight: 'bold', fontSize: 16, marginBottom: 20, display: 'flex', flexDirection: 'column', gap: 10 }}>
        {complianceCriteria.map(item => (
          <div key={item} style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start', gap: 10 }}>
            <label style={{ whiteSpace: 'pre-line', flex: 1 }}>{item}</label>
            <label style={{ position: 'relative', display: 'inline-block', width: 20, height: 20 }}>
              <input
                type="checkbox"
                name={item}
                checked={checkedItems[item]}
                onChange={handleCheckboxChange}
                style={{ opacity: 0, width: 20, height: 20, margin: 0, position: 'absolute', left: 0, top: 0, cursor: 'pointer' }}
              />
              <span style={{
                position: 'absolute',
                top: 0,
                left: 0,
                height: 20,
                width: 20,
                backgroundColor: '#fff',
                border: '2px solid #2e7d32',
                borderRadius: 4,
                boxSizing: 'border-box'
              }} />
              {checkedItems[item] && (
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="#2e7d32"
                  strokeWidth="3"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  style={{
                    position: 'absolute',
                    top: 2,
                    left: 4,
                    width: 12,
                    height: 16,
                    pointerEvents: 'none'
                  }}
                >
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              )}
            </label>
          </div>
        ))}
      </div>

      {error && (
        <div style={{ color: '#d32f2f', fontWeight: 'bold', marginBottom: 20 }}>
          {error}
        </div>
      )}
      <button
        onClick={handleConfirm}
        disabled={confirmButtonDisabled}
        style={{
          backgroundColor: '#2e7d32',
          color: 'white',
          fontWeight: 'bold',
          fontSize: 24,
          padding: '15px 0',
          width: '100%',
          border: 'none',
          borderRadius: 6,
          cursor: confirmButtonDisabled ? 'not-allowed' : 'pointer',
          marginBottom: 20,
          boxShadow: '0 4px 6px rgba(0,0,0,0.2)',
          opacity: confirmButtonDisabled ? 0.6 : 1
        }}
      >
        CONFIRM
      </button>

      <button
        onClick={handleNonCompliant}
        disabled={nonCompliantButtonDisabled}
        style={{
          backgroundColor: '#d32f2f',
          color: 'white',
          fontWeight: 'bold',
          fontSize: 24,
          padding: '15px 0',
          width: '100%',
          border: 'none',
          borderRadius: 6,
          cursor: nonCompliantButtonDisabled ? 'not-allowed' : 'pointer',
          boxShadow: '0 4px 6px rgba(0,0,0,0.2)',
          opacity: nonCompliantButtonDisabled ? 0.6 : 1
        }}
      >
        NON COMPLIANT
      </button>
    </div>
  );
}

export default Consent;
